
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34132',
  depVersions: {
  "documents-public-ui": "static-1.34132",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34137",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1993",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5458",
  "hs-test-utils": "static-1.7872",
  "hub-http": "static-1.6083",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11308",
  "I18n": "static-7.1593",
  "jasmine-immutable": "static-1.2882",
  "jasmine-runner": "static-1.6335",
  "lodash": "static-1.3",
  "quartz": "static-1.6816",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16515",
  "reporting-data": "static-1.66799",
  "reporting-testing-lib": "static-1.8732",
  "reporting-visualizations": "static-1.58875",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4633",
  "webpack-env": "static-1.54",
  "atom": "static-1.4935",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2357",
  "classnames": "static-2.10",
  "cssUtils": "static-1.758",
  "customer-data-filters-ui": "static-1.39148",
  "customer-data-objects": "static-1.7517",
  "customer-data-property-utils": "static-1.7945",
  "data-fetching-client": "static-1.9542",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4394",
  "flux-actions": "static-1.321",
  "FormsCommonComponents": "static-1.85454",
  "FormUrlGenerator": "static-2.4586",
  "foundations-components": "static-1.7648",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11616",
  "icons": "static-2.635",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7024",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3720",
  "property-translator": "static-1.5274",
  "quartz-config": "static-1.594",
  "quartz-core": "static-1.6035",
  "quick-fetch": "static-1.3799",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5236",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8030",
  "reference-resolvers-lite": "static-1.7950",
  "report-customization-components": "static-1.12709",
  "reporting-enablement": "static-1.22323",
  "reporting-reports": "static-1.66477",
  "reporting-snowflake": "static-1.55417",
  "reporting-ui-components": "static-2.64070",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4507",
  "sales-content-partitioning": "static-1.8801",
  "SalesContentIndexUI": "static-3.9005",
  "sanitize": "static-1.4339",
  "sanitize-text": "static-1.8010",
  "self-service-api": "static-1.10107",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1617",
  "signup-constants": "static-1.18541",
  "signup-ui-lego-core": "static-1.20551",
  "signup-ui-url-generator": "static-2.7900",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4634",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10858",
  "ui-addon-i18n": "static-1.11011",
  "ui-addon-react-router-dom": "static-1.9410",
  "ui-addon-upgrades": "static-9.17757",
  "ui-asset-management-lib": "static-1.10804",
  "ui-images": "static-2.1118",
  "UIComponents": "static-3.8255",
  "usage-tracker": "static-1.7200",
  "usage-tracker-container": "static-1.7190",
  "usage-tracker-core": "static-1.7050",
  "usage-tracker-public": "static-1.7011",
  "viral-links-lib": "static-1.6905",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3290",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3093",
  "quartz-webpack": "static-1.3040",
  "ai-components-ui-library": "static-1.8552",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4706",
  "foundations-theming": "static-1.4277",
  "quartz-auth": "static-1.491",
  "ui-business-units-lib": "static-1.8898",
  "usage-tracker-session-replay": "static-1.4886",
  "foundations-theming-base": "static-1.3262",
  "HeadJS": "static-2.728",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2983",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4191",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7789",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3481",
  "persist-promise": "static-1.3573",
  "reporting-client-types": "static-1.2409",
  "foundations-components-legacy": "static-1.673",
  "hs-story-utils": "static-1.9291",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9643",
  "hubspotter-http": "static-1.4539",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7114",
  "crm-message-bus": "static-1.42567",
  "customer-data-filters-ui-msw-helpers": "static-1.21583",
  "customer-data-objects-ui-components": "static-1.12878",
  "customer-data-reference-ui-components": "static-1.13014",
  "customer-data-ui-utilities": "static-1.9689",
  "framework-builder-read-service-client": "static-1.3894",
  "framework-data-schema-quick-fetch": "static-1.6643",
  "framework-data-schema-resolvers": "static-1.6738",
  "inbound-db-properties-service-client": "static-1.3732",
  "multi-account-reference-resolvers": "static-1.842",
  "onboarding-tours": "static-1.16353",
  "reporting-datasets-permissions-lib": "static-1.13250",
  "ui-addon-teams": "static-1.21336",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67829",
  "customer-data-properties": "static-1.51000",
  "forms-ai-lib": "static-1.4100",
  "forms-utils-lib": "static-1.12300",
  "foundations-components-test-utils": "static-1.5131",
  "react-dnd-compat": "static-1.4485",
  "react-tinymce": "static-1.54811",
  "tinymce-config": "static-2.53937",
  "ui-gdpr-components": "static-1.10213",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3917",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1399",
  "ui-fonts": "static-1.570",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.813",
  "mobile-manifest-mixins": "static-1.503",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.481",
  "quartz-i18n": "static-1.491",
  "quartz-routing": "static-1.246",
  "quartz-test": "static-1.491",
  "quartz-tracking": "static-1.195",
  "batch-promise": "static-1.1416",
  "external-options-client-types": "static-1.4045",
  "react-colorpicker": "static-2.10076",
  "copilot-toolkit": "static-1.10711",
  "data-quality-ui-library": "static-1.12490",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6328",
  "reporting-action-components": "static-1.40834",
  "reporting-insights-lib": "static-1.1265",
  "reporting-plugins": "static-1.10063",
  "ui-addon-draggable-compat": "static-2.4119",
  "ui-addon-opt": "static-4.8249",
  "ui-shepherd-react": "static-3.10011",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24915",
  "hubspot-apollo-client": "static-1.4744",
  "chirp-fetch": "static-1.1748",
  "sales-templates-service-types-lib": "static-1.4053",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5588",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3966",
  "timezone-utils": "static-2.5109",
  "bender-build-tools": "static-1.3018",
  "chatspot-core": "static-1.20619",
  "bend-plugin-foundations-theming": "static-1.2760",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9641",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3684",
  "crm-pipelines-api-client-types": "static-1.4026",
  "multi-currency-client-types": "static-1.3576",
  "getting-started-shared-tasks": "static-1.18068",
  "growth-data-modal": "static-1.5224",
  "growth-onboarding-confetti": "static-1.2937",
  "growth-onboarding-next-action-utils": "static-1.1473",
  "navigation-components": "static-1.17497",
  "onboarding-tours-client": "static-1.4567",
  "onboarding-tours-utils": "static-1.419",
  "ui-shepherd-tracker": "static-1.7392",
  "ui-universal-auth": "static-1.8787",
  "user-context": "static-1.4965",
  "cms-field-types": "static-1.4674",
  "content-icons-ui": "static-1.2182",
  "integrations-lib": "static-1.15630",
  "calling-global-api": "static-1.63934",
  "calling-internal-common": "static-1.31165",
  "calling-lifecycle-internal": "static-1.65316",
  "calling-lifecycle-messages": "static-1.57610",
  "commerce-products-lib": "static-1.9031",
  "crm-links": "static-1.6134",
  "file-manager-components": "static-1.23122",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.552",
  "inbounddb-objects-service-types": "static-1.4109",
  "meetings-icalendar-utils-lib": "static-1.497",
  "object-builder-ui-client": "static-1.48226",
  "pipeline-validation-client-types": "static-1.3850",
  "property-value-citations": "static-1.1614",
  "pulse": "static-1.389",
  "smart-property-lib": "static-1.6198",
  "tiered-pricing": "static-1.933",
  "ui-addon-iframeable": "static-1.8912",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19587",
  "tinymce-themes": "static-1.55907",
  "data-token-picker": "static-1.16159",
  "hub-http-contrib": "static-1.2908",
  "interframe": "static-3.4627",
  "tinymce-data": "static-1.40022",
  "tinymce-plugins": "static-1.57051",
  "ui-addon-sales-email": "static-1.5078",
  "magpie-lib": "static-1.5459",
  "magpie-types": "static-1.4919",
  "simple-logging-lib": "static-1.2915",
  "content-assistance-lib": "static-1.7540",
  "dashboard-lib": "static-1.80904",
  "ExportDialog": "static-6.10254",
  "hubspot-prosemirror": "static-1.17798",
  "hubspot-prosemirror-plugins": "static-1.17790",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8558",
  "campaign-roi-lib": "static-1.8481",
  "feedback-loader": "static-1.29005",
  "apollo-link-hub-http": "static-2.4516",
  "hubspot-apollo-cache": "static-1.203",
  "growth-monetization-service-types": "static-1.4364",
  "nav-client-types": "static-1.2222",
  "purchase-motions-api": "static-1.5591",
  "trials-service-types": "static-1.3765",
  "growth-onboarding-next-action-components": "static-1.1501",
  "user-context-client": "static-1.4478",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.590",
  "unified-auth-core-lib": "static-1.582",
  "getting-started-shared-tasks-store": "static-1.17186",
  "integrations-error-boundary-lib": "static-1.13045",
  "integrations-tracking-lib": "static-1.5455",
  "native-integrations-shared-strings": "static-1.7652",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10239",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31171",
  "shared-worker-versioning": "static-1.10904",
  "calling-usage-tracker": "static-1.6406",
  "voice-sms-access-library": "static-1.440",
  "customer-data-tracking": "static-1.6747",
  "commerce-permissions": "static-1.628",
  "products-iframe-lib": "static-1.7518",
  "products-ui-components-shared-msw-handlers": "static-1.10025",
  "location-customization-utils-lib": "static-1.8771",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4019",
  "video-components-external": "static-1.10784",
  "video-data-lib": "static-1.34442",
  "directed-graph": "static-1.804",
  "event-emitter": "static-1.812",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5414",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9726",
  "fsm": "static-1.3595",
  "policy-lib": "static-1.6643",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9789",
  "navigation-messaging": "static-1.6824",
  "FileManagerLib": "static-1.38762",
  "NamespacedHubStyle": "static-2.8956",
  "FileManagerCore": "static-1.38621",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12170",
  "layout-dnd-utils": "static-1.11145",
  "react-codemirror": "static-1.10491",
  "ui-addon-emoji-picker": "static-1.9752",
  "ui-brand-identity-lib": "static-1.14368",
  "ui-addon-video-player": "static-1.8561",
  "ui-coaching-tips": "static-1.28121",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8423",
  "payment-link-components": "static-1.23114",
  "EmailSignatureEditor": "static-1.24034",
  "eligibility-engine-service-types": "static-1.3046",
  "universal-page-editor-lib": "static-1.2866",
  "calling-orchestration-schema": "static-1.35217",
  "sales-views-client-types": "static-1.4135",
  "crm-record-cards-service-types": "static-1.3503",
  "content-media-composition-data-lib": "static-1.11726",
  "content-media-compositions": "static-2.15733",
  "media-bridge-lib": "static-1.18681",
  "trellis-story-utils": "static-1.4385",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5704",
  "FileManagerImages": "static-1.36273",
  "video-components": "static-1.12787",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4396",
  "video-embed": "static-1.35276",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67904",
  "layout-data-lib": "static-1.9470",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6446",
  "commerce-tours-lib": "static-1.5824",
  "growth-onboarding-reliability": "static-1.4951",
  "sales-checkout-service-client": "static-1.3533",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21425",
  "sales-email-signature-service-client": "static-1.3708",
  "social-insights-client-types": "static-1.21588",
  "outpost": "static-1.4064",
  "advanced-menus-core": "static-1.14910",
  "advanced-menus-lib": "static-1.11878",
  "ui-memberships-settings-lib": "static-1.33628",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14909",
  "simple-menus-lib": "static-1.16426"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34132",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34137",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1993",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5458",
  "hs-test-utils": "/hs-test-utils/static-1.7872",
  "hub-http": "/hub-http/static-1.6083",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11308",
  "I18n": "/I18n/static-7.1593",
  "jasmine-immutable": "/jasmine-immutable/static-1.2882",
  "jasmine-runner": "/jasmine-runner/static-1.6335",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6816",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16515",
  "reporting-data": "/reporting-data/static-1.66799",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8732",
  "reporting-visualizations": "/reporting-visualizations/static-1.58875",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4633",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4935",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2357",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.758",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39148",
  "customer-data-objects": "/customer-data-objects/static-1.7517",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7945",
  "data-fetching-client": "/data-fetching-client/static-1.9542",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4394",
  "flux-actions": "/flux-actions/static-1.321",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85454",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4586",
  "foundations-components": "/foundations-components/static-1.7648",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11616",
  "icons": "/icons/static-2.635",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7024",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3720",
  "property-translator": "/property-translator/static-1.5274",
  "quartz-config": "/quartz-config/static-1.594",
  "quartz-core": "/quartz-core/static-1.6035",
  "quick-fetch": "/quick-fetch/static-1.3799",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5236",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8030",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7950",
  "report-customization-components": "/report-customization-components/static-1.12709",
  "reporting-enablement": "/reporting-enablement/static-1.22323",
  "reporting-reports": "/reporting-reports/static-1.66477",
  "reporting-snowflake": "/reporting-snowflake/static-1.55417",
  "reporting-ui-components": "/reporting-ui-components/static-2.64070",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4507",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8801",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9005",
  "sanitize": "/sanitize/static-1.4339",
  "sanitize-text": "/sanitize-text/static-1.8010",
  "self-service-api": "/self-service-api/static-1.10107",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1617",
  "signup-constants": "/signup-constants/static-1.18541",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20551",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7900",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4634",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10858",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11011",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9410",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17757",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10804",
  "ui-images": "/ui-images/static-2.1118",
  "UIComponents": "/UIComponents/static-3.8255",
  "usage-tracker": "/usage-tracker/static-1.7200",
  "usage-tracker-container": "/usage-tracker-container/static-1.7190",
  "usage-tracker-core": "/usage-tracker-core/static-1.7050",
  "usage-tracker-public": "/usage-tracker-public/static-1.7011",
  "viral-links-lib": "/viral-links-lib/static-1.6905",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3290",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3093",
  "quartz-webpack": "/quartz-webpack/static-1.3040",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8552",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4706",
  "foundations-theming": "/foundations-theming/static-1.4277",
  "quartz-auth": "/quartz-auth/static-1.491",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8898",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4886",
  "foundations-theming-base": "/foundations-theming-base/static-1.3262",
  "HeadJS": "/HeadJS/static-2.728",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2983",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4191",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7789",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3481",
  "persist-promise": "/persist-promise/static-1.3573",
  "reporting-client-types": "/reporting-client-types/static-1.2409",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.673",
  "hs-story-utils": "/hs-story-utils/static-1.9291",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9643",
  "hubspotter-http": "/hubspotter-http/static-1.4539",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7114",
  "crm-message-bus": "/crm-message-bus/static-1.42567",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21583",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12878",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13014",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9689",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3894",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6643",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6738",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3732",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.842",
  "onboarding-tours": "/onboarding-tours/static-1.16353",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13250",
  "ui-addon-teams": "/ui-addon-teams/static-1.21336",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67829",
  "customer-data-properties": "/customer-data-properties/static-1.51000",
  "forms-ai-lib": "/forms-ai-lib/static-1.4100",
  "forms-utils-lib": "/forms-utils-lib/static-1.12300",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5131",
  "react-dnd-compat": "/react-dnd-compat/static-1.4485",
  "react-tinymce": "/react-tinymce/static-1.54811",
  "tinymce-config": "/tinymce-config/static-2.53937",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10213",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3917",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1399",
  "ui-fonts": "/ui-fonts/static-1.570",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.813",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.503",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.481",
  "quartz-i18n": "/quartz-i18n/static-1.491",
  "quartz-routing": "/quartz-routing/static-1.246",
  "quartz-test": "/quartz-test/static-1.491",
  "quartz-tracking": "/quartz-tracking/static-1.195",
  "batch-promise": "/batch-promise/static-1.1416",
  "external-options-client-types": "/external-options-client-types/static-1.4045",
  "react-colorpicker": "/react-colorpicker/static-2.10076",
  "copilot-toolkit": "/copilot-toolkit/static-1.10711",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12490",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6328",
  "reporting-action-components": "/reporting-action-components/static-1.40834",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1265",
  "reporting-plugins": "/reporting-plugins/static-1.10063",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4119",
  "ui-addon-opt": "/ui-addon-opt/static-4.8249",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10011",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24915",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4744",
  "chirp-fetch": "/chirp-fetch/static-1.1748",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4053",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5588",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3966",
  "timezone-utils": "/timezone-utils/static-2.5109",
  "bender-build-tools": "/bender-build-tools/static-1.3018",
  "chatspot-core": "/chatspot-core/static-1.20619",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2760",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9641",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3684",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4026",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3576",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18068",
  "growth-data-modal": "/growth-data-modal/static-1.5224",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2937",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1473",
  "navigation-components": "/navigation-components/static-1.17497",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4567",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.419",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7392",
  "ui-universal-auth": "/ui-universal-auth/static-1.8787",
  "user-context": "/user-context/static-1.4965",
  "cms-field-types": "/cms-field-types/static-1.4674",
  "content-icons-ui": "/content-icons-ui/static-1.2182",
  "integrations-lib": "/integrations-lib/static-1.15630",
  "calling-global-api": "/calling-global-api/static-1.63934",
  "calling-internal-common": "/calling-internal-common/static-1.31165",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65316",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57610",
  "commerce-products-lib": "/commerce-products-lib/static-1.9031",
  "crm-links": "/crm-links/static-1.6134",
  "file-manager-components": "/file-manager-components/static-1.23122",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.552",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4109",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.497",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48226",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3850",
  "property-value-citations": "/property-value-citations/static-1.1614",
  "pulse": "/pulse/static-1.389",
  "smart-property-lib": "/smart-property-lib/static-1.6198",
  "tiered-pricing": "/tiered-pricing/static-1.933",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8912",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19587",
  "tinymce-themes": "/tinymce-themes/static-1.55907",
  "data-token-picker": "/data-token-picker/static-1.16159",
  "hub-http-contrib": "/hub-http-contrib/static-1.2908",
  "interframe": "/interframe/static-3.4627",
  "tinymce-data": "/tinymce-data/static-1.40022",
  "tinymce-plugins": "/tinymce-plugins/static-1.57051",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5078",
  "magpie-lib": "/magpie-lib/static-1.5459",
  "magpie-types": "/magpie-types/static-1.4919",
  "simple-logging-lib": "/simple-logging-lib/static-1.2915",
  "content-assistance-lib": "/content-assistance-lib/static-1.7540",
  "dashboard-lib": "/dashboard-lib/static-1.80904",
  "ExportDialog": "/ExportDialog/static-6.10254",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17798",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17790",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8558",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8481",
  "feedback-loader": "/feedback-loader/static-1.29005",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4516",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.203",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4364",
  "nav-client-types": "/nav-client-types/static-1.2222",
  "purchase-motions-api": "/purchase-motions-api/static-1.5591",
  "trials-service-types": "/trials-service-types/static-1.3765",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1501",
  "user-context-client": "/user-context-client/static-1.4478",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.590",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.582",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17186",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13045",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5455",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7652",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10239",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31171",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10904",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6406",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.440",
  "customer-data-tracking": "/customer-data-tracking/static-1.6747",
  "commerce-permissions": "/commerce-permissions/static-1.628",
  "products-iframe-lib": "/products-iframe-lib/static-1.7518",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10025",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8771",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4019",
  "video-components-external": "/video-components-external/static-1.10784",
  "video-data-lib": "/video-data-lib/static-1.34442",
  "directed-graph": "/directed-graph/static-1.804",
  "event-emitter": "/event-emitter/static-1.812",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5414",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9726",
  "fsm": "/fsm/static-1.3595",
  "policy-lib": "/policy-lib/static-1.6643",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9789",
  "navigation-messaging": "/navigation-messaging/static-1.6824",
  "FileManagerLib": "/FileManagerLib/static-1.38762",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8956",
  "FileManagerCore": "/FileManagerCore/static-1.38621",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12170",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11145",
  "react-codemirror": "/react-codemirror/static-1.10491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9752",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14368",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8561",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28121",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8423",
  "payment-link-components": "/payment-link-components/static-1.23114",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24034",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3046",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2866",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35217",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3503",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11726",
  "content-media-compositions": "/content-media-compositions/static-2.15733",
  "media-bridge-lib": "/media-bridge-lib/static-1.18681",
  "trellis-story-utils": "/trellis-story-utils/static-1.4385",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5704",
  "FileManagerImages": "/FileManagerImages/static-1.36273",
  "video-components": "/video-components/static-1.12787",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4396",
  "video-embed": "/video-embed/static-1.35276",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67904",
  "layout-data-lib": "/layout-data-lib/static-1.9470",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6446",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5824",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4951",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3533",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21425",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3708",
  "social-insights-client-types": "/social-insights-client-types/static-1.21588",
  "outpost": "/outpost/static-1.4064",
  "advanced-menus-core": "/advanced-menus-core/static-1.14910",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11878",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33628",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14909",
  "simple-menus-lib": "/simple-menus-lib/static-1.16426"
}
};
